import React from 'react'

const Header:React.FC = () => {
  return (
    <section id="header">
      <div className="mx-auto container flex text-center md:text-left py-20">
        <h1 className="text-xl md:text-3xl px-8 md:px-0"><a href="/" className="text-white">j</a>o.</h1>
      </div>
    </section>
  )
}

export default Header